import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function GameSessionDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"Game Session Details"}
                            endpoint={"game-session/details"}
                            relations={["operator_game_config", "operator_game_config.game_config", "player_currency", "player_currency.player", "player_currency.currency"]} />
}

export default GameSessionDetailsPage;